import api from './api';

// Dashboard Stats
export const getAdminStats = async () => {
  const response = await api.get('/admin/stats');
  return response.data;
};

// User Management
export const getUsers = async (params = {}) => {
  const response = await api.get('/admin/users', { params });
  return response.data;
};

export const getUser = async (id) => {
  const response = await api.get(`/admin/users/${id}`);
  return response.data;
};

export const updateUserRole = async (id, role) => {
  const response = await api.put(`/admin/users/${id}/role`, { role });
  return response.data;
};

// Coupon Management
export const createCoupon = async (data) => {
  const response = await api.post('/admin/coupons', data);
  return response.data;
};

export const getCoupons = async (params = {}) => {
  const response = await api.get('/admin/coupons', { params });
  return response.data;
};

export const getCoupon = async (id) => {
  const response = await api.get(`/admin/coupons/${id}`);
  return response.data;
};

export const updateCoupon = async (id, data) => {
  const response = await api.put(`/admin/coupons/${id}`, data);
  return response.data;
};

export const deleteCoupon = async (id) => {
  const response = await api.delete(`/admin/coupons/${id}`);
  return response.data;
};

export const getCouponRedemptions = async (id, params = {}) => {
  const response = await api.get(`/admin/coupons/${id}/redemptions`, { params });
  return response.data;
};

// Affiliate Management
export const getAffiliates = async (params = {}) => {
  const response = await api.get('/admin/affiliates', { params });
  return response.data;
};

export const getAffiliate = async (id) => {
  const response = await api.get(`/admin/affiliates/${id}`);
  return response.data;
};

export const updateAffiliate = async (id, data) => {
  const response = await api.put(`/admin/affiliates/${id}`, data);
  return response.data;
};

export default {
  getAdminStats,
  getUsers,
  getUser,
  updateUserRole,
  createCoupon,
  getCoupons,
  getCoupon,
  updateCoupon,
  deleteCoupon,
  getCouponRedemptions,
  getAffiliates,
  getAffiliate,
  updateAffiliate
};
